import { all } from 'redux-saga/effects';
import * as schoolRollSaga from './containers/school-roll/saga';
import * as studentRollSaga from './containers/student-roll/saga';
import * as teacherRollSaga from './containers/teacher-roll/saga';
import * as classRollSaga from './containers/class-roll/saga';
import * as quickUploadSaga from './containers/quick-upload/saga';
import * as editStudentSaga from './containers/edit-student/saga';
import * as assignUserSaga from './containers/assign-user/saga';
import * as editTeacherSaga from './containers/edit-teacher/saga';
import * as editClassSaga from './containers/edit-class/saga';
import * as rollOverSaga from './containers/roll-over/saga';
import * as extendResultSaga from './containers/extend-result/saga';
import * as defaultCoursesSaga from './containers/default-course/saga';
import * as downloadCertificatesSaga from './containers/download-certificates/saga';
import * as teacherViewSaga from './containers/teacher-view/saga';
import * as assignCoursesSaga from './containers/assign-courses/saga';
import * as assignUPFCoursesSaga from './containers/assign-courses-upf/saga';
import * as assignLegacyCoursesSaga from './containers/assign-courses-legacy/saga';
import * as assignCourseAdminSaga from './containers/manage-assigned-courses/saga';

function* mainSaga() {
    yield all([
        schoolRollSaga.getLicenceCapSummarySaga(),
        classRollSaga.getClassroomsSaga(),
        schoolRollSaga.getCourseCountriesSaga(),
        classRollSaga.getProductCoursesSaga(),
        classRollSaga.addClassSaga(),
        studentRollSaga.getStudentsSaga(),
        schoolRollSaga.getYearGroupSaga(),
        studentRollSaga.downloadStudentRollSaga(),
        studentRollSaga.unassignStudentsSaga(),
        studentRollSaga.downloadSignInCardSaga(),
        studentRollSaga.addStudentSaga(),
        studentRollSaga.deleteStudentSaga(),
        studentRollSaga.bulkPasswordChangeStudentsSaga(),
        studentRollSaga.getClassroomGroupsSaga(),
        quickUploadSaga.downloadTemplateForQuickUploadSaga(),
        quickUploadSaga.quickUploadSaga(),
        editStudentSaga.unassignStudentsByClassIdSaga(),
        editStudentSaga.getStudentsByUserProfileIdSaga(),
        editStudentSaga.editStudentSaga(),
        assignUserSaga.getStudentClassroomsRelationSaga(),
        assignUserSaga.getTeacherClassroomsRelationSaga(),
        assignUserSaga.assignStudentSaga(),
        assignUserSaga.assignTeacherSaga(),
        assignUserSaga.assignTeacherToClassroomSaga(),
        teacherRollSaga.getTeachersSaga(),
        teacherRollSaga.addTeacherSaga(),
        teacherRollSaga.downloadTeacherRollSaga(),
        teacherRollSaga.downloadSignInCardSaga(),
        teacherRollSaga.unassignTeachersSaga(),
        teacherRollSaga.deleteTeacherSaga(),
        teacherRollSaga.sendVerificationEmailSaga(),
        editTeacherSaga.editTeacherSaga(),
        editTeacherSaga.getTeacherByUserProfileIdSaga(),
        editTeacherSaga.downloadClassroomStudentsSignInCardSaga(),
        editTeacherSaga.unassignTeachersByClassIdSaga(),
        classRollSaga.downloadClassroomStudentsSignInsCardsSaga(),
        editTeacherSaga.unassignTeachersByClassIdSaga(),
        editTeacherSaga.sendPasswordLinkSaga(),
        editTeacherSaga.sendEmailVerificationLinkSaga(),
        classRollSaga.downloadClassRollSaga(),
        classRollSaga.getSchoolCoursesSaga(),
        classRollSaga.deleteClassroomsSaga(),
        classRollSaga.getUPFCoursesSaga(),
        classRollSaga.getNewCoursesSaga(),
        editClassSaga.renameClassroomGroupSaga(),
        editClassSaga.getClassByClassroomIdSaga(),
        editClassSaga.downloadStudentSignInCardsSaga(),
        editClassSaga.saveModifiedClassSaga(),
        editClassSaga.unassignTeacherSaga(),
        editClassSaga.downloadTeachersSignInCardSaga(),
        editClassSaga.deleteClassroomGroupSaga(),
        editClassSaga.changeClassroomCourseSaga(),
        editClassSaga.addGroupSaga(),
        editClassSaga.changeCourseCarryOverSaga(),
        editClassSaga.handleCountryDropdownChangesSaga(),
        rollOverSaga.rollOverVerifyContentSaga(),
        rollOverSaga.downloadTemplateForRolloverSaga(),
        rollOverSaga.downloadSchoolRollDataRolloverSaga(),
        rollOverSaga.performRollOverSaga(),
        rollOverSaga.downloadRolloverSignInCardsSaga(),
        extendResultSaga.verifyExtendResultSaga(),
        extendResultSaga.extendResultSaga(),
        defaultCoursesSaga.getDefaultCoursesSaga(),
        defaultCoursesSaga.showCourseDetailsSaga(),
        defaultCoursesSaga.fetchingCourseDetailsSaga(),
        downloadCertificatesSaga.downloadCertificatesSetupSaga(),
        downloadCertificatesSaga.downloadCertificatesSaga(),
        downloadCertificatesSaga.getAcademicYearSaga(),
        downloadCertificatesSaga.getCertificatesSummarySaga(),
        downloadCertificatesSaga.setTeacherSaga(),
        downloadCertificatesSaga.setClassroomSaga(),
        downloadCertificatesSaga.setGroupSaga(),
        downloadCertificatesSaga.getClassroomGroupsSaga(),
        downloadCertificatesSaga.onDatePickerChangeSaga(),
        defaultCoursesSaga.saveDefaultCoursesSaga(),
        teacherViewSaga.getTeacherAuthTokenRequestSaga(),
        assignCoursesSaga.getCountryYearGroupsSaga(),
        assignCoursesSaga.getYearGroupsSaga(),
        assignCoursesSaga.getCourseCountrySaga(),
        assignCoursesSaga.getProductCourseSaga(),
        assignCoursesSaga.getSchoolCourseSaga(),
        assignUPFCoursesSaga.getFilteredUPFCourseSaga(),
        assignLegacyCoursesSaga.getFilteredLegacyCourseSaga(),
        assignCourseAdminSaga.getDefaultCoursesSaga(),
        assignCourseAdminSaga.checkCommonTasksSaga(),
        assignCourseAdminSaga.assignCoursesSaga()
    ]);
}

export default mainSaga;



// WEBPACK FOOTER //
// ./app/main-saga.js